import React, { useEffect, useState } from 'react'
import useAuthRequest from '../../../services/requests.service'
import InvoiceTable from './InvoicesTable';
import { DotLoader } from 'react-spinners';

const options = {
    day: 'numeric', // Two-digit day (e.g., 28)
    month: 'short', // Short month name (e.g., "janv." for January)
    year: 'numeric', // Four-digit year (e.g., 2024)
    timeZone: 'UTC', // Set the time zone to UTC to match the Unix timestamp
};

const InformationView = ({ page, subscriptions, isLoading, invoice, invoices, stripeProducts, onGoToPlans }) => {

    const request = useAuthRequest();
    const [startDate, setStartDate] = useState('');
    const [nextDate, setNextDate] = useState('');


    useEffect(() => {

        if (subscriptions && subscriptions[0]) {
            const date = new Date(subscriptions[0].start_date * 1000); // Multiply by 1000 to convert from seconds to milliseconds
            const formattedDate = date.toLocaleDateString('fr-FR', options);
            setStartDate(formattedDate);

        }

        if (invoice) {
            const date = new Date(invoice.next_payment_attempt * 1000); // Multiply by 1000 to convert from seconds to milliseconds
            const formattedDate = date.toLocaleDateString('fr-FR', options);
            setNextDate(formattedDate);
        }

        return () => {

        }
    }, [subscriptions])

    const generatePortailLink = async (subscriptionId, flowType) => {
        const content = { customerId: page.customerId, url: `${window.location.href}`, subscriptionId, flowType }
        let resLink = await request.postDataAPI('stripe/portal-link', content);
        if (resLink.session.url) {
            window.location.href = resLink.session.url;
        }
    }


    return (
        <>
        {isLoading ? <div className="  min-h-[200px]  flex justify-center items-center"> <DotLoader size={60} color="#6076E7" /></div> :<div>
            {subscriptions?.length === 0 && (
                <div className="flex flex-col items-center justify-center py-16 gap-4 text-center">
                    <p className="text-slate-500">Aucun abonnement actif pour le moment.</p>
                    <button
                        onClick={onGoToPlans}
                        className="px-4 py-2 bg-royalblue-500 text-white rounded-lg text-sm font-medium hover:bg-royalblue-600 transition-colors"
                    >
                        Aller dans "Mes abonnements" →
                    </button>
                </div>
            )}


            {
                subscriptions?.length > 0 && <div className='flex flex-col gap-6'>
                    <h2 className="text-xl text-slate-800 dark:text-slate-100 font-bold mb-2">Abonnements actifs</h2>

                    {['permanent', 'seasonal'].map((type) => {
                        const group = subscriptions.filter(s => (s.metadata?.planType || 'permanent') === type);
                        if (group.length === 0) return null;
                        return (
                            <div key={type}>
                                <div className={`text-xs font-semibold uppercase tracking-wide mb-3 ${type === 'seasonal' ? 'text-amber-500' : 'text-royalblue-500'}`}>
                                    {type === 'permanent' ? '♾️ Plans permanents' : '🌿 Plans saisonniers'}
                                </div>
                                <div className='flex flex-col gap-3'>
                                {group.map((sub, index) => {
                        const planType = sub.metadata?.planType || 'permanent';
                        const isSeasonal = planType === 'seasonal';
                        const startDateSub = new Date(sub.start_date * 1000).toLocaleDateString('fr-FR', options);
                        const cancelAt = sub.cancel_at
                            ? sub.cancel_at * 1000
                            : isSeasonal ? sub.start_date * 1000 + 90 * 24 * 60 * 60 * 1000 : null;
                        const endDateSub = cancelAt ? new Date(cancelAt).toLocaleDateString('fr-FR', options) : null;
                        const borderColor = isSeasonal ? 'border-amber-400' : 'border-royalblue-500';
                        const badgeColor = isSeasonal ? 'bg-amber-500' : 'bg-royalblue-500';

                        const statusConfig = {
                            active:              { label: 'Actif',           cls: 'bg-emerald-100 text-emerald-700' },
                            trialing:            { label: 'Période gratuite', cls: 'bg-emerald-100 text-emerald-700' },
                            past_due:            { label: 'Paiement en retard', cls: 'bg-orange-100 text-orange-700' },
                            unpaid:              { label: 'Impayé',          cls: 'bg-red-100 text-red-700' },
                            paused:              { label: 'Suspendu',        cls: 'bg-slate-100 text-slate-600' },
                            incomplete:          { label: 'Incomplet',       cls: 'bg-orange-100 text-orange-700' },
                            incomplete_expired:  { label: 'Expiré',          cls: 'bg-red-100 text-red-700' },
                            canceled:            { label: 'Annulé',          cls: 'bg-red-100 text-red-700' },
                        };
                        const statusInfo = statusConfig[sub.status] ?? { label: sub.status, cls: 'bg-slate-100 text-slate-600' };

                        return (
                            <div key={sub.id} className={`relative flex flex-col border-[1px] ${borderColor} rounded-md p-4 pt-14`}>
                                <div className={`absolute top-2 left-0 ${badgeColor} text-white text-sm font-medium px-3 py-2 rounded-r-lg`}>
                                    {isSeasonal ? '🌿 Saisonnier' : '♾️ Permanent'} · depuis le {startDateSub}
                                </div>
                                <span className={`absolute top-2 right-3 text-xs font-semibold px-2 py-1 rounded-full ${statusInfo.cls}`}>
                                    {statusInfo.label}
                                </span>
                                <div className='flex flex-col gap-1'>
                                    <h3 className='font-bold text-black'>{sub.items.data[0]?.productName}</h3>
                                    <span className='font-normal text-slate-500'>
                                        Sièges : <span className='font-semibold'>{sub.items.data[0]?.quantity}</span>
                                    </span>
                                    {isSeasonal ? (
                                        endDateSub && (() => {
                                            const daysLeft = Math.ceil((cancelAt - Date.now()) / (1000 * 60 * 60 * 24));
                                            const unitAmount = sub.items.data[0]?.price?.unit_amount;
                                            const qty = sub.items.data[0]?.quantity ?? 1;
                                            const monthlyPrice = unitAmount ? (unitAmount / 100) * qty : null;
                                            const totalPrice = monthlyPrice ? monthlyPrice * 3 : null;
                                            return (
                                                <div className='flex flex-col gap-1 mt-1'>
                                                    {monthlyPrice !== null && (
                                                        <span className='font-normal text-slate-500'>
                                                            Tarif : <span className='font-semibold'>{monthlyPrice.toFixed(2)}€/mois</span>
                                                            <span className='text-xs text-slate-400 ml-1'>(total {totalPrice.toFixed(2)}€ sur 3 mois)</span>
                                                        </span>
                                                    )}
                                                    <span className='font-normal text-slate-500'>
                                                        Date d'expiration : <span className='font-semibold text-amber-600'>{endDateSub}</span>
                                                    </span>
                                                    <span className='font-normal text-slate-500'>
                                                        Jours restants : <span className={`font-semibold ${daysLeft <= 14 ? 'text-red-600' : 'text-amber-600'}`}>
                                                            {daysLeft > 0 ? `${daysLeft} jour${daysLeft > 1 ? 's' : ''}` : 'Abonnement expiré'}
                                                        </span>
                                                    </span>
                                                </div>
                                            );
                                        })()
                                    ) : (
                                        <>
                                            {sub.status === 'trialing' && sub.trial_end && (() => {
                                                const trialEnd = new Date(sub.trial_end * 1000);
                                                const trialEndStr = trialEnd.toLocaleDateString('fr-FR', options);
                                                const trialDaysLeft = Math.ceil((trialEnd - Date.now()) / (1000 * 60 * 60 * 24));
                                                return (
                                                    <div className='flex flex-col gap-1 mt-1 p-2 bg-emerald-50 rounded-md border border-emerald-200'>
                                                        <span className='text-xs font-semibold text-emerald-600 uppercase tracking-wide'>Période gratuite en cours</span>
                                                        <span className='font-normal text-slate-500'>
                                                            Fin de la période gratuite : <span className='font-semibold text-emerald-600'>{trialEndStr}</span>
                                                        </span>
                                                        <span className='font-normal text-slate-500'>
                                                            Jours restants : <span className={`font-semibold ${trialDaysLeft <= 7 ? 'text-red-600' : 'text-emerald-600'}`}>
                                                                {trialDaysLeft > 0 ? `${trialDaysLeft} jour${trialDaysLeft > 1 ? 's' : ''}` : 'Période expirée'}
                                                            </span>
                                                        </span>
                                                    </div>
                                                );
                                            })()}
                                            {nextDate && <>
                                                <span className='font-normal text-slate-500'>Prochain paiement : <span className='font-semibold'>{nextDate}</span></span>
                                                <span className='font-normal text-slate-500'>Tarif : <span className='font-semibold'>{invoice?.amount_due ? invoice.amount_due / 100 : 0}€/mois</span></span>
                                            </>}
                                        </>
                                    )}
                                </div>
                                {isSeasonal && (
                                    <div
                                        onClick={() => generatePortailLink(null, 'payment_method_update')}
                                        className='flex justify-between items-center hover:cursor-pointer hover:bg-slate-50 px-2 py-3 mt-2 rounded'
                                    >
                                        <h3 className='font-bold text-black'>Mettre à jour le paiement</h3>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path fill="black" fillRule="evenodd" d="m7.053 2.158l7.243 7.256a.66.66 0 0 1 .204.483a.705.705 0 0 1-.204.497c-2.62 2.556-5.145 5.023-7.575 7.401c-.125.117-.625.408-1.011-.024c-.386-.433-.152-.81 0-.966l7.068-6.908l-6.747-6.759c-.246-.339-.226-.652.06-.939c.286-.287.607-.3.962-.04Z" /></svg>
                                    </div>
                                )}
                                {!isSeasonal && (() => {
                                    const cancelUnlockDate = new Date(sub.start_date * 1000 + 90 * 24 * 60 * 60 * 1000);
                                    const canCancel = new Date() > cancelUnlockDate;
                                    const cancelDateStr = cancelUnlockDate.toLocaleDateString('fr-FR', options);
                                    return (
                                        <>
                                            {!canCancel && (
                                                <div
                                                    onClick={() => generatePortailLink(null, 'payment_method_update')}
                                                    className='flex justify-between items-center hover:cursor-pointer hover:bg-slate-50 px-2 py-3 mt-2 rounded'
                                                >
                                                    <h3 className='font-bold text-black'>Mettre à jour le paiement</h3>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path fill="black" fillRule="evenodd" d="m7.053 2.158l7.243 7.256a.66.66 0 0 1 .204.483a.705.705 0 0 1-.204.497c-2.62 2.556-5.145 5.023-7.575 7.401c-.125.117-.625.408-1.011-.024c-.386-.433-.152-.81 0-.966l7.068-6.908l-6.747-6.759c-.246-.339-.226-.652.06-.939c.286-.287.607-.3.962-.04Z" /></svg>
                                                </div>
                                            )}
                                            <div
                                                title={!canCancel ? `Résiliation possible à partir du ${cancelDateStr}` : ''}
                                                onClick={canCancel ? () => generatePortailLink(sub.id) : undefined}
                                                className={`flex justify-between items-center px-2 py-3 mt-2 rounded transition-colors ${
                                                    canCancel
                                                        ? 'hover:cursor-pointer hover:bg-slate-50'
                                                        : 'opacity-40 cursor-not-allowed'
                                                }`}
                                            >
                                                <h3 className={`font-bold ${canCancel ? 'text-black' : 'text-slate-400'}`}>
                                                    Gérer abonnement {!canCancel && '🔒'}
                                                </h3>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path fill={canCancel ? 'black' : '#94a3b8'} fillRule="evenodd" d="m7.053 2.158l7.243 7.256a.66.66 0 0 1 .204.483a.705.705 0 0 1-.204.497c-2.62 2.556-5.145 5.023-7.575 7.401c-.125.117-.625.408-1.011-.024c-.386-.433-.152-.81 0-.966l7.068-6.908l-6.747-6.759c-.246-.339-.226-.652.06-.939c.286-.287.607-.3.962-.04Z" /></svg>
                                            </div>
                                        </>
                                    );
                                })()}
                            </div>
                        );
                    })}
                                </div>
                            </div>
                        );
                    })}
                </div>
            }

          {invoices?.data?.length > 0 && (
                <div className='flex flex-col gap-3 mt-8'>
                    <h2 className="text-xl text-slate-800 font-bold">Factures</h2>
                    <InvoiceTable invoices={invoices.data} />
                </div>
            )}
        </div>}

        </>
    )
}

export default InformationView